export default __webpack_public_path__ + "static/media/travel-details.01788470.svg";